module.exports = __webpack_public_path__ + "img/Warrior-nightelf-m-70.daff1860.gif";